<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        removed the task-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>.-->
        <span v-html="$t('notification.taskDeleted', {user: $_.get(activity, 'actorUser.name'), task: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
